import {
  SET_ACT_RECORD_DATA,
  CHANGE_ACT_RECORD_DATA,
  BLUR_ACT_RECORD_DATA,
  GET_REG_PLACE_SUGGESTIONS,
  GET_REG_PLACE_SUGGESTIONS_SUCCESS,
  GET_REG_PLACE_SUGGESTIONS_ERROR,
  LOAD_DRAFT_EMPTY
} from '../constants';
import { ACT_RECORD_FIELD_NAMES } from '../../constants/actRecord';

const initialField = {
  value: '',
  error: false,
  disabled: false
};

const initialState = {
  data: {
    [ACT_RECORD_FIELD_NAMES.date]: initialField,
    [ACT_RECORD_FIELD_NAMES.number]: initialField,
    [ACT_RECORD_FIELD_NAMES.regPlace]: initialField
  },
  blur: {
    [ACT_RECORD_FIELD_NAMES.date]: false,
    [ACT_RECORD_FIELD_NAMES.number]: false,
    [ACT_RECORD_FIELD_NAMES.regPlace]: false
  },
  regPlaceNameSuggestions: {
    list: null,
    fetching: false,
    fetchingError: false
  }
};

const actRecord = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACT_RECORD_DATA:
      return {
        ...state,
        ...action.payload,
        blur: {}
      };
    case BLUR_ACT_RECORD_DATA:
      return {
        ...state,
        blur: {
          ...state.blur,
          [action.payload]: true
        }
      };
    case CHANGE_ACT_RECORD_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload
        },
        blur: {
          ...state.blur,
          [Object.keys(action.payload)[0]]: false
        }
      };
    case GET_REG_PLACE_SUGGESTIONS:
      return {
        ...state,
        regPlaceNameSuggestions: {
          ...state.regPlaceNameSuggestions,
          fetching: true,
          fetchingError: false
        }
      };
    case GET_REG_PLACE_SUGGESTIONS_ERROR:
      return {
        ...state,
        regPlaceNameSuggestions: {
          ...state.regPlaceNameSuggestions,
          fetching: false,
          fetchingError: true,
          list: null
        }
      };
    case GET_REG_PLACE_SUGGESTIONS_SUCCESS:
      const list = action.payload || [];

      return {
        ...state,
        regPlaceNameSuggestions: {
          ...state.regPlaceNameSuggestions,
          fetching: false,
          fetchingError: false,
          list: [...list]
        }
      };
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default actRecord;
